<template>
  <page title="Magazine / Contents">
    <div slot="page-header-right">
      <modal-opener
        :component="require('./AddContentModal.vue').default"
        :props="{ added: () => contents.load() }"
      >
        <button class="button is-primary" slot="trigger">
          <b-icon icon="plus"></b-icon>
          <span>Add Content</span>
        </button>
      </modal-opener>
    </div>

    <div class="box">
      <b-table
        class="is-middle"
        :loading="contents.loading"
        :data="contents.data"
        :current-page="contents.current_page"
        :per-page="contents.per_page"
        :total="contents.total"
        @page-change="
          page => {
            contents.changePage(page);
          }
        "
        paginated
        backend-pagination
        pagination-position="bottom"
      >
        <template slot-scope="{ row: content }">
          <b-table-column label="Path">{{ content.path }}</b-table-column>

          <b-table-column label="Pages" centered>
            {{ content.pages_count }}
          </b-table-column>

          <b-table-column label="Created At">
            {{ content.created_at }}
          </b-table-column>
        </template>
      </b-table>
    </div>
  </page>
</template>

<script>
export default {
  data() {
    return {
      contents: new window.PaginatedRemoteCollection(
        "/admin/api/magazine/contents?include=pages_count"
      )
    };
  },

  created() {
    this.contents.load();
  }
};
</script>
